import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ArcTeamMemberGetByIdArgs {
  @Field(t => Int, { nullable: true })
  id?: number

  @Field(t => Int, { nullable: true })
  teamId?: number

  @Field(t => Int, { nullable: true })
  userId?: number

  public constructor (partial?: Partial<ArcTeamMemberGetByIdArgs>) {
    Object.assign(this, partial)
  }
}
